import { RouteComponentProps, withRouter } from 'react-router-dom';
import SideNavigation, {
  SideNavigationProps,
} from '@amzn/awsui-components-react/polaris/side-navigation';
import { Component } from 'react';
import { ParcelPlaybackStateInterface } from 'src/stores/app';
import { State } from '@hookstate/core';
import { isAdmin } from 'src/utils/UserPermissionUtils';
import { debug } from 'src/utils/utils';

interface ParcelPlaybackConfigurationNavigationLocalProps extends RouteComponentProps {
  parcelPlaybackState?: State<ParcelPlaybackStateInterface>;
}

class ParcelPlaybackConfigNavigationLocal extends Component<ParcelPlaybackConfigurationNavigationLocalProps> {
  // If the provided link is empty, do not redirect pages
  onFollowHandler(event: CustomEvent<SideNavigationProps.FollowDetail>) {
    event.preventDefault();
    if (event.detail.href) {
      this.props.history.push(event.detail.href.substring(1));
    }
  }

  checkUserIsAdmin() {
    const username = this.props.parcelPlaybackState?.username.get();
    if (this.props.parcelPlaybackState?.isAdmin.get() === undefined) {
      isAdmin(username!).then((result) => {
        this.props.parcelPlaybackState?.isAdmin.set(result);
      });
    }
  }

  render() {
    debug(`ParcelPlaybackConfigNavigationLocal render()`);
    if (this.props.location.pathname === '/') this.props.location.pathname = '/ParcelSearch';

    // this.checkUserIsAdmin();  TODO: Reinstate post Pilot, assumption is that Sesame will be used

    const home = {
      text: 'Parcel Playback',
      href: '#/',
    };

    let sideNavigationItems: SideNavigationProps.Item[] = [
      {
        type: 'link',
        text: 'Parcel Search',
        href: '#/ParcelSearch',
      },
      {
        type: 'link',
        text: 'Camera Links',
        href: '#/CameraLinks',
      },
    ];
    return (
      <SideNavigation
        activeHref={`#${this.props.location.pathname}`}
        header={home}
        items={sideNavigationItems}
        onFollow={this.onFollowHandler.bind(this)}
      />
    );
  }
}

export const ParcelPlaybackConfigNavigation = withRouter(ParcelPlaybackConfigNavigationLocal);
